import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, finalize, tap, throwError } from 'rxjs';
import { LoggingService } from '../services/logging.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);
  const loggingService = inject(LoggingService);
  let errorMessage = '';

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        errorMessage = (event.body as any)?.errorMessage;
      }
    }),
    catchError((error: HttpErrorResponse) => {
      errorMessage = error.message ?? 'An unknown error occurred!';
      console.log('Error Interceptor: error = ', error);
      if (error.status != null && error.status != undefined) {
        switch (true) {
          case error.status === 404:
            errorMessage = `This resource does not exist.`;
            break;
          case error.status === 401:
            errorMessage = `Unauthorized.`;
            break;
          case error.status === 403:
            errorMessage = `Not Allowed.`;
            break;
          case error.status >= 500 && error.status <= 599:
            errorMessage = `Internal Server Error.`;
            break;
          default:
            errorMessage = `An Error Occured.`;
        }
      }

      loggingService.logException(error, 3,"errorInterceptor");

      return throwError(() => error);
    }),
    finalize(() => {
      if (errorMessage) {
        snackBar.open(errorMessage, 'Close', {
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
          panelClass: ['error-snackbar'],
          duration: 3000,
        });
      }
    }),
  );
};
